"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var i18n_1 = require("../i18n");
var storage_1 = __importDefault(require("./storage"));
var ASYNC_TRANSLATION_MAP = {};
exports.setTranslations = function (config) {
    (config || []).forEach(function (c) {
        if (typeof c.translations === 'function') {
            addAsyncTranslation(c.locale, c.translations);
        }
        else {
            i18next_1.default.addResourceBundle(c.locale, 'translation', c.translations, true);
        }
    });
    i18next_1.default.changeLanguage(i18next_1.default.language);
};
var hasAsyncTranslation = function (locale) {
    var localeTranslations = ASYNC_TRANSLATION_MAP[locale];
    if (localeTranslations) {
        return localeTranslations.status === 'ready' || localeTranslations.status === 'rejected';
    }
    return false;
};
var addAsyncTranslation = function (locale, getTranslations) {
    ASYNC_TRANSLATION_MAP[locale] = { load: getTranslations, status: 'ready' };
};
var loadAsyncTranslation = function (locale) { return __awaiter(_this, void 0, void 0, function () {
    var config, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = ASYNC_TRANSLATION_MAP[locale];
                if (!(config && config.status === 'ready')) return [3, 4];
                config.status = 'pending';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4, config.load()];
            case 2:
                result = _a.sent();
                config.status = 'resolved';
                return [2, result];
            case 3:
                err_1 = _a.sent();
                config.status = 'rejected';
                return [2, {}];
            case 4: return [2, []];
        }
    });
}); };
exports.initi18nConfig = function (options) {
    i18next_1.default.use(react_i18next_1.initReactI18next).init(__assign({ lng: storage_1.default.getLanguageIsoCode() || 'pt-BR', fallbackLng: 'pt-BR', keySeparator: false, nsSeparator: false, interpolation: {
            escapeValue: false,
        }, react: {
            useSuspense: false,
        }, resources: {
            'pt-BR': { translation: i18n_1.ptBR },
            'en-US': { translation: i18n_1.enUS },
        } }, options));
    var loadLanguage = function (lng) {
        if (hasAsyncTranslation(lng)) {
            var load = function () { return __awaiter(_this, void 0, void 0, function () {
                var translations;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, loadAsyncTranslation(lng)];
                        case 1:
                            translations = _a.sent();
                            i18next_1.default.addResourceBundle(lng, 'translation', translations, true);
                            i18next_1.default.changeLanguage(lng);
                            return [2];
                    }
                });
            }); };
            load();
        }
    };
    i18next_1.default.on('initialized', function (opt) {
        if (opt.lng) {
            loadLanguage(opt.lng);
        }
        else {
            loadLanguage('pt-BR');
        }
    });
    i18next_1.default.on('languageChanged', function (lng) {
        storage_1.default.setLanguageIsoCode(lng);
        loadLanguage(lng);
    });
};
